module.exports = {"340322100":"城关镇","340322101":"新集镇","340322103":"小溪镇","340322104":"双忠庙镇","340322105":"小圩镇","340322106":"东刘集镇","340322107":"头铺镇","340322108":"大新镇","340322109":"武桥镇","340322110":"朱顶镇","340322111":"浍南镇","340322112":"申集镇","340322200":"沱湖乡","340322201":"临北回族乡","340322400":"安徽五河经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/340322.json
// module id = 1169
// module chunks = 0